const OpenSessionList = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-candidat/candidatDashboard/OpenSessionList.vue"
  );

const UserSessionDashboardTable = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/shared/userDashboard/UserDashboardSessionTable.vue"
  );

export default [
  {
    path: "open-sessions",
    name: "candidate-openSessions",
    component: OpenSessionList,
  },
  {
    path: "planned-sessions",
    name: "candidate-plannedSessions",
    component: UserSessionDashboardTable,
    props: {
      additionalFilters: {
        o: "-date,-time",
      },
    },
  },
];
